<template>
    <div class="hot-sales-side-content">
        <div class="title">
            {{ $t('products.hotSales') }}
        </div>

        <div class="hot-sales-list pointer-cursor" v-for="item in hotProduct" :key="item.id" @click="gotoDetails(item.id)">
            <div class="img" >
                <el-image :src="`${item.cover}`" fit="cover" style="width: 87px; height: 87px"/>
            </div>

            <div class="name">
                {{ item.name }}
            </div>
        </div>

    </div>
</template>

<script lang="ts" setup>
import { ConstantField } from '@/constant/ConstantField';
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action } from '@/typeDefine/CommonTypes';
import { GetHotProductResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';

const hotProduct: Ref<GetHotProductResponse['data']['hotProduct']> = ref([])

onMounted(() => {
    requestHotProduct()
})

const requestHotProduct: Action = async () => {
    const response: GetHotProductResponse = await Api.instance.getHotProductList()

    UtilMethods.showMessageToast(response,false)

    if(response.code === ResponseCode.OK) {
        hotProduct.value = response.data.hotProduct
    }
}

const gotoDetails: Action<[number]> = (id: number) => {
    router.push({
        name: 'productDetails',
        params: {
            id,
        }
    })
}
</script>

<style lang="css" scoped>
.hot-sales-side-content {
    margin-top: 30px;
}
.hot-sales-side-content .title {
    border-left: 5px solid var(--primary-color);
    padding-left: 17px;
    margin-bottom: 20px;
    font-size: 24px;
}
.hot-sales-side-content .hot-sales-list {
    display: flex;
    border-bottom: 2px solid #F3F3F3;
    transition: all ease 0.5s;
    margin-bottom: 10px;
}
.hot-sales-side-content .hot-sales-list:hover .name{
    color: var(--primary-color);
}

.hot-sales-side-content .hot-sales-list .img {
    margin-right: 10px;
    padding: 3px;
}
.hot-sales-side-content .hot-sales-list .name {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: all ease 0.5s;
}

@media (max-width: 1200px) {
    .hot-sales-side-content{
        display: none;
    }
}
</style>

<style>
.hot-sales-side-content .el-image__inner {
    width: 100%;
    height: 100%;
    margin: 0;
}
</style>